module.exports = "img/flags/FI.4fb83a3.png";